import { useEffect } from 'react';

import { currentLanguage, syncDocumentLanguage, useMessages } from './thervumitra/i18n';
import { catalogUrl, dashboardUrl } from './thervumitra/links';
import NewsletterForm from './thervumitra/site/NewsletterForm';
import { getConfig } from './platformShim';

// "Teach" column title (only this site's footer has it: the instructor
// dashboard is for course teams).
const TEACH: Record<string, string> = { en: 'Teach', ta: 'கற்பிக்க' };

// ThervuMitra footer for the frontend-base site (instructor dashboard,
// notifications): the classic MFEs' footer (build/mfe/thervumitra/Footer.jsx,
// same strings, newsletter form and theme classes) with a Teach column.
const ThervuMitraFooter = () => {
  const t = useMessages();
  const lang = currentLanguage();
  const config = getConfig();
  useEffect(syncDocumentLanguage, []);

  const columns = [
    {
      title: t.footerCompany,
      links: [[t.about, catalogUrl('about')], [t.footerContact, catalogUrl('contact')], [t.blog, catalogUrl('blog')]],
    },
    {
      title: t.footerLearn,
      links: [[t.explore, catalogUrl('courses')], [t.lpTitle, catalogUrl('learning-path')],
        [t.myDashboard, dashboardUrl()]],
    },
    {
      title: TEACH[lang] || TEACH.en,
      links: [['Studio', `${String(config.BASE_URL || '').replace(/\/$/, '')}/authoring/home`]],
    },
    {
      title: t.footerLegal,
      links: [[t.terms, catalogUrl('tos')], [t.privacy, catalogUrl('privacy')]],
    },
  ];

  return (
    <footer className="bm-footer bm-footer--teach" lang={lang}>
      <div className="bm-footer__inner">
        <div className="bm-footer__brand">
          <a href={catalogUrl()} className="bm-footer__logo">
            <img src={config.LOGO_URL} alt={config.SITE_NAME || 'ThervuMitra'} />
          </a>
          <p>{t.footerLine}</p>
        </div>
        {columns.map(column => (
          <nav key={column.title} className="bm-footer__column" aria-label={column.title}>
            <h2>{column.title}</h2>
            <ul>
              {column.links.map(([label, href]) => <li key={label}><a href={href}>{label}</a></li>)}
            </ul>
          </nav>
        ))}
        <div className="bm-footer__column bm-footer__newsletter">
          <h2>{t.newsletterTitle}</h2>
          <p>{t.newsletterText}</p>
          <NewsletterForm />
        </div>
      </div>
      <div className="bm-footer__legal">
        <span>© {new Date().getFullYear()} ThervuMitra. {t.initiative}</span>
      </div>
    </footer>
  );
};

export default ThervuMitraFooter;
